import { TEssenceFromGroup, TEssenceGroups } from '@lib/core/characters/types/essences';
import { selectServiceProductCategory } from '@lib/core/service/selectors';
import { store } from '@lib/core/service/store';
import {
  HEETS_ESSENCE_AROMA_ID,
  HEETS_ESSENCE_INTENSITY_ID,
  TEREA_ESSENCE_AROMA_ID,
  TEREA_ESSENCE_INTENSITY_ID,
} from '@lib/tools/shared/pmi/essences/consts';

export const isCurrentEssenceGroup = (essenceGroup: TEssenceGroups): boolean => {
  const productCategory = selectServiceProductCategory(store?.getState());
  return essenceGroup.name === productCategory;
};

export const isEssenceAroma = (essenceObj: TEssenceFromGroup): boolean =>
  essenceObj.identifier === TEREA_ESSENCE_AROMA_ID || essenceObj.identifier === HEETS_ESSENCE_AROMA_ID;

export const isEssenceIntensity = (essenceObj: TEssenceFromGroup): boolean =>
  essenceObj.identifier === TEREA_ESSENCE_INTENSITY_ID || essenceObj.identifier === HEETS_ESSENCE_INTENSITY_ID;
